import { Injectable } from '@angular/core';
import { TransactionalService } from '../transactional.service';
import { IResponse } from '../../../models/dtos/response.interface';
import { Observable } from 'rxjs';
import { IBlog } from '../../../models/dtos/get/blog.interface';
import { HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class BlogService {

  constructor(private _transactionalService: TransactionalService) { }

  public get(): Observable<IResponse<IBlog[]>> {
    return this._transactionalService.get<IResponse<IBlog[]>>("get-blogs");
  }

  public find(slug: string): Observable<IResponse<IBlog>> {
    let params: HttpParams = new HttpParams().set('slug', slug);
    return this._transactionalService.get<IResponse<IBlog>>("get-blog?" + params.toString());
  }
}
